import React from 'react';
import { Button } from '@material-ui/core';

export default (tipo: string) => {
  const array = [
    {
      name: 'invoiceNumber',
      label: 'Número NFS'
    },
    {
      name: 'branchId',
      label: 'Código Filial'
    },
    {
      name: 'totalAmount',
      label: 'Valor NF'
    },
    {
      name: 'issueDate',
      label: 'Data Emissão'
    },
    {
      name: 'dueDate',
      label: 'Data Vencimento'
    },
    {
      name: 'invoiceNote',
      label: 'Observação'
    },
    {
      name: 'itemQuantity',
      label: 'Quantidade Item'
    },
    {
      name: 'numericCode',
      label: 'Numérico'
    },
    {
      name: 'alphaId',
      label: 'Alfa'
    },
    {
      name: 'colorAbbreviation',
      label: 'Cor'
    },
    {
      name: 'carrierName',
      label: 'Transportadora'
    },
    {
      name: 'netValue',
      label: 'Valor Líquido'
    },
    {
      name: 'invoiceSeq',
      label: 'Número Item'
    },
    {
      name: 'invoiceOriginNumber',
      label: 'Nota Origem'
    },
    {
      name: 'invoiceOriginIssueDate',
      label: 'Data Nota Origem'
    },
    {
      name: 'purchaseOrderId',
      label: 'Número Pedido'
    },
    {
      name: 'operationTaxCode',
      label: 'CFOP'
    },
    {
      name: 'operationTaxName',
      label: 'Tipo'
    },
    {
      name: 'productName',
      label: 'Nome produto'
    },
    {
      name: 'qualityIndicator',
      label: 'AQP'
    },
    {
      name: 'productDescription',
      label: 'Descrição produto'
    }
  ];

  const unloadColumns = [
    {
      name: 'providerDocumentId',
      label: 'Documento do Prestador'
    },
    {
      name: 'nrNfeServico',
      label: 'Número NFS-e'
    },
    {
      name: 'invoiceKeyCode',
      label: 'Código de Verificação'
    },
    {
      name: 'invoiceLink',
      label: 'Link NFS-e',
      options: {
        customBodyRender: (value: string) => {
          const handleClick = () => window.open(value, '_blank');

          if (!value) return null;

          return (
            <div>
              <Button color="primary" variant="text" onClick={handleClick} style={{ padding: 0, border: 0, margin: 0 }}>
                PDF
              </Button>
            </div>
          );
        }
      }
    }
  ];

  if (tipo === 'U') return array.concat(unloadColumns);

  return array;
};
